var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-collapse"},[_c('div',{staticClass:"vuestic-collapse__header",class:{
      'vuestic-collapse__header--no-header': _vm.noHeader,
    },on:{"click":function($event){_vm.onHeaderClick()}}},[(_vm.noHeader)?[_vm._t("header")]:_c('button',{class:{'vuestic-collapse__header__button btn btn-primary' : _vm.level === 10, 
      'vuestic-collapse__header__button btn btn-warning': _vm.level === 2,
      'vuestic-collapse__header__button btn btn-danger': _vm.level === 0,
      'vuestic-collapse__header__button btn btn-info': _vm.level === 1}},[_vm._t("header")],2)],2),_vm._v(" "),_c('div',{ref:"collapseBody",staticClass:"vuestic-collapse__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29dce4b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/postavke/postavkeCollapse.vue
// module id = ajSa
// module chunks = 114